import React from "react";

import { INVOICE_STATUS, SALE_TYPE } from "../../../../../../Common/constants";

export const InvoiceAgingColumnFormatter = (cellContent) => {
  function calculateDays(dueDateStr) {
    const dueDate = new Date(dueDateStr);
    const currentDate = new Date();
    dueDate.setHours(23); 
    dueDate.setMinutes(59);
    dueDate.setSeconds(59);

    // Calculate the difference in days
    const timeDifferenceInDays = Math.floor((dueDate - currentDate) / (1000 * 60 * 60 * 24));

    return timeDifferenceInDays;
  }

  const aging = calculateDays(cellContent?.due_date);

  return (
    <>
      {cellContent.sale_type !== SALE_TYPE.SALE_RETURN.value &&
        cellContent.status !== INVOICE_STATUS.PAID.value &&
        cellContent.status !== INVOICE_STATUS.VOID.value &&
        typeof aging !== "undefined" && (
          <div
            style={{
              background: aging > 0 ? "#2db83d" : aging === 0 ? "#e96102" : "#e90216",
              padding: "5px",
              textAlign: "center",
              borderRadius: "5px",
              color: "white",
            }}
          >
            {aging > 0
              ? `Due in ${aging} day${aging === 1 ? "" : "s"}`
              : aging === 0
                ? `Due Immediately`
                : `Overdue by ${Math.abs(aging)} day${Math.abs(aging) === 1 ? "" : "s"}`}
          </div>
        )}
    </>
  );
};